import React, { useState, useEffect } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { Button, notification, Select, Input } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useNavigate
import './UserOnboardingPage.css';
import { postRequest } from '../../api';
import PopUpInfo from '../../components/PopUpInfo/PopUpInfo';
import { styles } from "./PaymentMethodStyles.js";

const { Option } = Select;

const PaymentForm = ({ setOnboardingData, onboardingData }) => {
  const stripe = useStripe();
  const elements = useElements();
  const location = useLocation();
  const navigate = useNavigate(); // Initialize navigate
  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [showPopUp, setShowPopUp] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('free');
  const [cardOwnerName, setCardOwnerName] = useState('');

  localStorage.setItem("plan",location.state.selectedPlan.title)

  useEffect(() => {
    if (location.state && location.state.selectedPlan) {
      setSelectedPlan(location.state.selectedPlan);
    }
  }, [location.state]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    const customerEmail = localStorage.getItem('useremail');
    let id = localStorage.getItem('userid');
    const userId = Number(id);


    if (!userId || !customerEmail) {
      notification.error({
        message: 'Missing Information',
        description: 'User information is missing. Please sign in again.', 
        duration: 10
      });
      return;
    }

    setLoading(true);

    const cardElement = elements.getElement(CardElement);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: cardOwnerName,
        email: customerEmail,
      }
    });

    if (error) {
      notification.error({ message: 'Payment Error', description: error.message, duration: 10 });
      setLoading(false);
      return;
    }

    const planIdMap = {
      'free': process.env.REACT_APP_FREE_PLAN,
      '/month': process.env.REACT_APP_MONTHLY_PLAN,
      '/year': process.env.REACT_APP_YEARLY_PLAN,
    };
    let title=location.state.selectedPlan.price

    const planId = planIdMap[title] ; 

    try {
      const response = await postRequest('/stripe/create-subscription', {
        paymentMethodId: paymentMethod.id,
        planId: planId,
      });

      if (response.error) {
        notification.error({ message: 'Payment Error', description: response.error, duration: 10 });
      } else {
        notification.success({ message: 'Payment Success', description: 'Your payment was successful!', duration: 10 });
        navigate('/onboarding/get-to-know-you',{state:{selectedPlan}}); 
      }
    } catch (error) {
      notification.error({ message: 'Payment Error', description: error.message, duration: 10 });
    }

    setLoading(false);
  };

  return (
    <>
      {showPopUp && <PopUpInfo onClose={() => setShowPopUp(false)} />}
      <form onSubmit={handleSubmit} className="payment-form">
        <h1>Set Up Payment</h1>
        <p>We use Stripe, a safe and efficient online payment processing platform to ensure that your information is secure and protected.</p>
        <div className="form-group">
          <label htmlFor="payment-method">Choose your payment method</label>
          <div className="icon-container" onClick={() => setShowPopUp(true)}>
            <QuestionCircleOutlined className="custom-icon" />
          </div>        
          <Select id="payment-method" value={paymentMethod} onChange={setPaymentMethod}>
            <Option value="card">Credit or Debit Card</Option>
          </Select>
        </div>
        <div style={styles.formGroup}>
          <label style={styles.labelStyle} htmlFor="card-owner">Card Owner Name</label>
          <Input
            id="card-owner"
            value={cardOwnerName}
            onChange={(e) => setCardOwnerName(e.target.value)}
            placeholder="Enter card owner's name"
            style={styles.input}
          />
        </div>
        <div className="form-group">
          <label htmlFor="card-details">Card Details</label>
          <CardElement id="card-details" className="stripe-element" />
        </div>
        <Button type="primary" htmlType="submit" disabled={!stripe || loading}>
          {loading ? 'Processing...' : 'Finish'}
        </Button>
      </form>
    </>
  );
};

export default PaymentForm;
